//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The shipping type (method) id
*
* 
*  * STANDARD_MAIL value: 1 - Standardversand im Brief 
*  * REGISTERED_MAIL value: 2 - Einwurfeinschreiben 
*  * REGISTERED_DELIVERY value: 3 - Übergabeeinschreiben 
*  * INSURED_PARCEL value: 4 - Versichertes Postpaket 
*  * EMAIL value: 5 - E-Mail 
*  * UNSPECIFIED value: 6 - unspezifiziert 
*  * PICKUP value: 7 - Selbstabholung 
*/
@Serializable
enum class ShippingMethodId(val value: kotlin.Int) {

    @SerialName(value = "1")
    STANDARD_MAIL(1),

    @SerialName(value = "2")
    REGISTERED_MAIL(2),

    @SerialName(value = "3")
    REGISTERED_DELIVERY(3),

    @SerialName(value = "4")
    INSURED_PARCEL(4),

    @SerialName(value = "5")
    EMAIL(5),

    @SerialName(value = "6")
    UNSPECIFIED(6),

    @SerialName(value = "7")
    PICKUP(7);

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value.toString()

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is ShippingMethodId) "$data" else null

    /**
    * Returns a valid [ShippingMethodId] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): ShippingMethodId? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

